/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

const useRanking = ({
  rankingFetched, fetchRankingList,
}) => {
  useEffect(() => {
    if (!rankingFetched) {
      fetchRankingList();
    }
  }, [rankingFetched]);
};

export default useRanking;
